import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, Toaster } from 'sonner';
import { KeyRound, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { liveApi } from './liveClient';

export default function LiveChangePasswordPage() {
  const nav = useNavigate();
  const [cur, setCur] = useState('');
  const [nw, setNw] = useState('');
  const [conf, setConf] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (nw.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (nw !== conf) { toast.error('Passwords do not match'); return; }
    setBusy(true);
    try {
      await liveApi().post('/livestream/viewer/change-password', { current_password: cur, new_password: nw });
      toast.success('Password updated');
      nav('/live/dashboard', { replace: true });
    } catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <Toaster richColors position="top-center" />
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 w-full max-w-md space-y-4">
        <div className="flex items-center gap-2 text-white"><KeyRound className="w-5 h-5 text-rose-400" /><h1 className="text-lg font-bold">Set a new password</h1></div>
        <p className="text-sm text-slate-300">For security, please change the default password.</p>
        <div><label className="text-xs text-slate-400">Current password</label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="bg-slate-900 border-slate-600 text-white" data-testid="cp-current" /></div>
        <div><label className="text-xs text-slate-400">New password</label><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} className="bg-slate-900 border-slate-600 text-white" data-testid="cp-new" /></div>
        <div><label className="text-xs text-slate-400">Confirm new password</label><Input type="password" value={conf} onChange={(e) => setConf(e.target.value)} className="bg-slate-900 border-slate-600 text-white" data-testid="cp-confirm" /></div>
        <Button onClick={submit} disabled={busy} className="w-full bg-rose-600 hover:bg-rose-700" data-testid="cp-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : null}Save
        </Button>
      </div>
    </div>
  );
}
